import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'reactstrap';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import AddressFrm from '../../../Shared/AddressFrm/AddressFrm';
import {clearAddress, setHomeNum} from '../../../Shared/AddressFrm/addressFrmSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {hideAppLoader, showAppLoader} from '../../../Shared/Loader/LoaderSlice';
import PopUp from '../../../Shared/Popup/PopUp';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import TextInput from '../../../Shared/TextInput/TextInput';
import {
  changeHandler,
  clearTimeSlots,
  clearValid,
  deliveryChangeHandler,
  deliveryValidateHandler,
  enableEdit,
  expandElement,
  getDeliveryNoProducts,
  populateForm,
  setIsShowFail,
  setSavedSuccessfullyVisible,
  showApprovePopupBusiness,
  startLoading,
  updateOrCancel,
} from './UpdateBusinessDeliverySlotSlice';
import {submitSelectedEMEIConfirmation} from './../IMEIDeviceRepairSlice';
const UpdateBusinessDeliverySlot = (props) => {
  const focusBtn = useRef(null);
  const {saveAs} = require('file-saver');
  const ics = require('ics');
  let sameNoteOrders = '';
  const checksameNoteOrders = () => {
    if (props.sameNoteOrders != false) {
      if (props.sameNoteOrders.some((x) => x.idx == props.idx)) {
        return (sameNoteOrders = 'true');
      }
    } else return 'false';
  };

  const addressData = {
    city: props.addressForm.form.cityName,
    street: props.addressForm.form.streetName,
    homeNum: props.data.houseNumber,
    slotTimeNoteOrder: checksameNoteOrders(),
    slotTimeDate: props.data.disptachDate.replace('/', '-').replace('/', '-'),
    slotTimeFrom: props.data.roundFrom,
  };

  const objectForUpdate = {
    Ban: props.data.banNo,
    DispatchOrder: props.data.disptachOrdNum,
    NoteOrder: props.data.noteOrder,
    deliveryRequestAction: 'SHIPMENT_CHANGE',
    NewCity: props.addressForm.form.cityName,
    NewStreet: props.addressForm.form.streetName,
    NewHome: props.addressForm.form.home,
    NewApartment: props.addressForm.form.apartment,
    NewDeliveryDate: props.form.lfdat,
    NewRoundFrom: props.form.waitFrom,
    NewRoundTo: props.form.waitTo,
    UserName: props.form.userName,
    PhoneForDelivery: props.form.phone,
    PhoneForDelivery2: props.form.phone2,
    PickLocation: props.form.pickLocation,
    Round: props.form.round,
    Comments: props.form.comments,
    isBusiness: true,
    SubscriberNoOrIMEI: props.selectedPhoneNumber || props.selectedIMEI,
  };

  useEffect(() => {
    if (props.form.isLoading == false) {
      props.hideAppLoader();
      if (props.elementIndex == props.idx) {
        focusBtn.current.focus();
      }
    }
  }, [props.form.isLoading]);

  useEffect(() => {
    if (props.isApprovePopupShow == false) {
      gaEvent(
        gaParams.DELIVERY_CANCEL_REJECT.category,
        gaParams.DELIVERY_CANCEL_REJECT.eventType,
        gaParams.DELIVERY_CANCEL_REJECT.eventParams,
      );
    }
  }, [props.isApprovePopupShow]);

  useEffect(() => {
    if (props.addressForm.form.streetName != '' && props.addressForm.form.cityName != '') {
      if (props.elementIndex == props.idx) {
        const street = props.data.street;
        const city = props.data.city;
        props.showAppLoader();
        props.startLoading(true);
        props.getDeliveryNoProducts(addressData);

        if (props.addressForm.form.streetName != street || props.addressForm.form.cityName != city) {
          props.clearTimeSlots();
        }
      }
    }
  }, [props.addressForm.form.streetName, props.addressForm.form.cityName]);

  useEffect(() => {
    if (props.addressForm.form.street == ' ' || props.addressForm.form.city == ' ') {
      props.hideAppLoader();
    }
  }, [props.addressForm.form.street, props.addressForm.form.city]);

  useEffect(() => {
    if (props.slotsCount == 1) {
      props.expandElement(0);
    }
  }, []);

  useEffect(() => {
    if (props.form.valid) {
      if (props.elementIndex == props.idx) {
        props.updateOrCancel(objectForUpdate);
        props.showAppLoader();
      }
    }
    if (!props.form.valid) {
      props.hideAppLoader();
    }
  }, [props.form.valid]);

  useEffect(() => {
    if (props.isEdit == false) {
      props.clearAddress(props.addressForm);
    }
  }, [props.isEdit]);

  useEffect(() => {
    props.clearValid();
    if (props.updateSuccess != '' || props.updateSuccess == false) {
      props.hideAppLoader();
    }
    if (props.updateSuccess == true && props.elementIndex == props.idx) {
      console.log(props);
      let sendingData = {
        orgId: props.selectedHetPayId || props.orgId,
        selectedNumber: props.selectedPhoneNumber,
        isPrivate: props.deviceRepairData?.isPrivate,
        selectedIMEI: props.deviceRepairData.selectedIMEI,
        isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value == true,
      };
      props.submitSelectedEMEIConfirmation(sendingData);
      props.enableEdit();
      props.hideAppLoader();
      props.showApprovePopupBusiness(false);
      if (props.isSavedSuccessfullyVisible === true) {
        setTimeout(() => props.setSavedSuccessfullyVisible(false), 3000);
      }
    }
  }, [props.updateSuccess]);

  const setCalendar = (props) => {
    gaEvent(gaParams.DELIVERY_CALENDAR_ADD.category, gaParams.DELIVERY_CALENDAR_ADD.eventType, gaParams.DELIVERY_CALENDAR_ADD.eventParams);
    let dateArr = props.data.deliverySlots[0].date.split('/');
    let eventDelivery = {
      start: [parseInt(dateArr[2]), parseInt(dateArr[1]), parseInt(dateArr[0]), parseInt(props.data.deliverySlots[0].start), 0],
      duration: {hours: 2},
      title: `שליחות ${window.Config.brand_Name_HE}`,
      description: setTitleAndLogo(props.data).title,
      location: '',
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
    };

    ics.createEvent(eventDelivery, (error, value) => {
      if (error) {
        return;
      }
      var file = new File([value], 'event.ics', {type: 'text/calendar;charset=utf8'});
      saveAs(file);
    });
  };

  const checkIfUpdateAllowed = (props) => {
    const currentDate = new Date();
    const [dd, mm, yyyy] = props.data.disptachDate.split('/');
    const dispatchDate = new Date(yyyy, mm - 1, dd);
    if (currentDate <= dispatchDate) {
      return true;
    } else {
      return false;
    }
  };

  const getCurrentDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = dd + '/' + mm + '/' + yyyy;
    return today;
  };

  const setShipmentType = (shipmentType) => {
    switch (shipmentType) {
      case 'איסוף':
        return 'החזרה של ציוד ';
        break;
      case 'מסירה':
        return 'קבלה של ציוד ';
        break;
      case 'איסוף ומסירה':
        return 'החזרה וקבלה של ציוד ';
        break;
      default:
        return '';
    }
  };

  const setTitleAndLogo = (props) => {
    switch (props.equipmentType) {
      case 'QUATTRO':
        return {title: setShipmentType(props.shipmentType) + 'קוואטרו', logo: require('../images/icons-truck-delivery.svg')};
        break;
      case 'QUATTRO,CELLULAR':
        return {
          title: setShipmentType(props.shipmentType) + 'אינטרנט וציוד סלולר/ סים',
          logo: require('../images/icons-truck-delivery.svg'),
        };
        break;
      case 'TRIPLE':
        return {title: setShipmentType(props.shipmentType) + 'טריפל', logo: require('../images/icons-truck-delivery.svg')};
        break;
      case 'BUNDLE':
        return {title: setShipmentType(props.shipmentType) + 'אינטרנט', logo: require('../images/icons-fast-wifi.svg')};
        break;
      case 'CELLULAR':
        return {title: setShipmentType(props.shipmentType) + 'סלולר', logo: require('../images/icons-sim.svg')};
        break;
      case 'TV':
        return {title: setShipmentType(props.shipmentType) + `${window.Config.brand_Name_HE} TV`, logo: require('../images/icons-4-k.svg')};
        break;
      case 'OTHER':
        return {title: 'קבלת שליחות / החזרת ציוד', logo: require('../images/icons-truck-delivery.svg')};
        break;
      case '':
        return {title: setShipmentType(props.shipmentType) + ' כמחווה שירותית', logo: require('../images/icons-truck-delivery.svg')};
        break;
      default:
        return '';
    }
  };

  const updateDelivery = (props) => {
    props.deliveryValidateHandler(props.form);
  };

  const showCancelPopUp = () => {
    props.showApprovePopupBusiness(true);
  };

  const CancelDelivery = () => {
    console.log(props);
    gaEvent(
      gaParams.DELIVERY_CANCEL_APPROVE.category,
      gaParams.DELIVERY_CANCEL_APPROVE.eventType,
      gaParams.DELIVERY_CANCEL_APPROVE.eventParams,
    );
    props.showAppLoader();
    const objectForCancel = {
      Ban: props.data.banNo,
      DispatchOrder: props.data.disptachOrdNum,
      NoteOrder: props.data.noteOrder,
      deliveryRequestAction: 'SHIPMENT_CANCEL',
      NewCity: props.data.city,
      NewStreet: props.data.street,
      NewHome: props.data.houseNumber,
      NewApartment: '',
      NewDeliveryDate: props.data.disptachDate,
      NewRoundFrom: props.data.roundFrom,
      NewRoundTo: props.data.roundTo,
      UserName: props.data.customerName,
      PhoneForDelivery: props.form.phone,
      PhoneForDelivery2: props.form.phone2,
      PickLocation: '',
      Round: '',
      SubscriberNoOrIMEI: props.selectedPhoneNumber || props.selectedIMEI,
    };
    if (checkIfUpdateAllowed(props)) {
      props.updateOrCancel(objectForCancel);
    } else {
      props.setIsShowFail(true);
    }
    props.hideAppLoader();
  };

  const enableEditAndSetHomeNum = (props) => {
    props.showAppLoader();
    gaEvent(gaParams.DELIVERY_UPDATE_CLICK.category, gaParams.DELIVERY_UPDATE_CLICK.eventType, gaParams.DELIVERY_UPDATE_CLICK.eventParams);
    props.setHomeNum({HomeNum: props.data.houseNumber, Apartment: props.data.apartment});
    props.enableEdit(props.data);
  };

  let selectDeliverySlot = (
    <ReactSelect
      preventKeyboard={false}
      required={true}
      error={props.form.errors.deliveryTime}
      getOptionLabel={(option) => option.value}
      getOptionValue={(option) => option.key}
      placeholder={props.form.deliveryTime ? props.form.deliveryTime : props.form.deliveryTimePlaceholder}
      isLoading={props.form.isLoading}
      value={props.deliveryTimeSlots.filter((option) => option.key === props.form.deliveryTime)}
      name='deliveryTime'
      options={props.deliveryTimeSlots}
      onChange={(e) =>
        props.deliveryChangeHandler({
          target: {
            name: 'deliveryTime',
            value: e.key,
            startDate: e.startDate,
            endDate: e.endDate,
            round: e.round,
            roundName: e.roundName,
            waitFrom: e.waitFrom,
            waitTo: e.waitTo,
            lfdat: e.lfdat,
            weekdayL: e.weekdayL,
            pickLocation: e.pickLocation,
          },
          form: props.form,
        })
      }
    />
  );

  let editAddress = (
    <div>
      <section className='data-container'>
        <AddressFrm cityDefault={props.populatedCity} streetDefault={props.populatedStreet} />
      </section>
      <section className='data-container'>
        <div className='headline'>מתי:</div>
        {selectDeliverySlot}
      </section>
      <section className='data-container'>
        <div className='headline'>איפה ניפגש?</div>
        <Row>
          <Col ms={4}>
            <TextInput
              error={props.form.errors.userName}
              placeholder='שם'
              id='userName'
              name='userName'
              maxLength='20'
              type='text'
              autoComplete='off'
              value={props.form.userName}
              onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              required='required'
            />
          </Col>
        </Row>
        <Row>
          <Col ms={4}>
            <TextInput
              error={props.form.errors.phone}
              placeholder='טלפון לבירורים '
              id='phone'
              name='phone'
              maxLength='10'
              type='number'
              pattern='[0-9]*'
              autoComplete='off'
              value={props.form.phone}
              onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              required='required'
            />
          </Col>
        </Row>
        {props.data.contactNo2 != '' ? (
          <Row>
            <Col ms={4}>
              <TextInput
                error={props.form.errors.phone2}
                placeholder='טלפון נוסף '
                id='phone2'
                name='phone2'
                maxLength='10'
                type='number'
                autoComplete='off'
                value={props.form.phone2}
                onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              />
            </Col>
          </Row>
        ) : null}
      </section>
      <section className='data-container'>
        <div className='headline'>הערות לשליח</div>
        <Row>
          <Col ms={4}>
            <TextInput
              error={props.form.errors.comments}
              placeholder='למשל, כניסה מסביב או להשאיר ליד הדלת'
              id='comments'
              name='comments'
              maxLength='50'
              type='text'
              autoComplete='off'
              value={props.form.comments}
              onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
            />
          </Col>
        </Row>
      </section>
      <div className='note'>
        <Row>
          <Col xs='1' className='note-star'>
            *
          </Col>
          <Col xs='11' className='pr-0'>
            חשוב שמי שיפגוש את השליח יהיה מעל גיל 18
          </Col>
        </Row>
        {props.data.equipmentType == 'CELLULAR' ? (
          <Row>
            <Col xs='1' className='note-star'>
              *
            </Col>
            <Col xs='11' className='pr-0'>
              אם אתם מקבלים כרטיס סים חדש, השליח יכול להשאיר אותו בתיבת הדואר, גם אם אתם לא בבית
            </Col>
          </Row>
        ) : null}
      </div>
    </div>
  );

  let currentAddress = (
    <div>
      {props.isSavedSuccessfullyVisible ? (
        <div className='saved-container'>
          <div className='saved'>
            <div className='saved__bg'></div>
            <div className='saved__success'>
              <Image src={require('../images/icons-v-ok.svg')} alt='ok' />
              <span>נשמר</span>
            </div>
          </div>
        </div>
      ) : null}
      <section className='data-container'>
        {<div className='headline'>איפה ניפגש?</div>}
        <div className='static-text'>{props.data.shipAddress}</div>
      </section>
      <section className='data-container'>
        <div className='headline'>מתי:</div>
        <div className='static-text'>
          <span className='static-text'>{props.data.dayOfWeek} &nbsp;</span>
          <span className='static-text'>{props.data.disptachDate} &nbsp; &nbsp; </span>
          <span className='static-text'>
            {props.data.roundFrom} - {props.data.roundTo}
          </span>
        </div>
      </section>
      <section className='data-container'>
        <div className='headline'>מי יפגוש את השליח?</div>
        <div className='static-text'>{props.data.recieverName}</div>
        <div>
          <div className='headline'> טלפון לבירורים:</div>
          <div className='static-text'>{props.data.contactNo1}</div>
          {props.data.contactNo2 != '' && props.data.contactNo2 != '*' ? <div className='static-text'>{props.data.contactNo2}</div> : null}
        </div>
      </section>
      <section className='data-container'>
        <div className='headline'>הערות לשליח</div>
        <div className='static-text'>{props.data.messengerText}</div>
      </section>
      <div className='note'>
        <Row>
          <Col xs='1' className='note-star'>
            *
          </Col>
          <Col xs='11' className='pr-0'>
            חשוב שתהיה מעל גיל 18
          </Col>
        </Row>
        {props.data.shipmentType != 'איסוף' ? (
          <Row>
            <Col xs='1' className='note-star'>
              *
            </Col>
            <Col xs='11' className='pr-0'>
              אם אתם מקבלים כרטיס סים חדש, השליח יכול להשאיר אותו בתיבת הדואר, גם כשאתם לא בבית
            </Col>
          </Row>
        ) : null}
      </div>
    </div>
  );

  let cancelEditModeFooter = (
    <Row>
      <Col className='edit-footer'>
        <div>
          <button className='btn-enabled' onClick={() => props.enableEdit()}>
            חזור
          </button>
        </div>
        <div>
          <button className='btn-delivery' onClick={() => updateDelivery(props)}>
            שמירה
          </button>
        </div>
      </Col>
    </Row>
  );

  let editModeFooter = (
    <Row>
      <Col className='edit-footer'>
        <div>
          <button className={checkIfUpdateAllowed(props) ? 'btn-enabled' : 'btn-disabled'} onClick={() => enableEditAndSetHomeNum(props)}>
            עריכה
          </button>
        </div>
        <div xs='6'>
          <button className={props.data.status == 'C' ? 'btn-disabled' : 'btn-enabled'} onClick={() => setCalendar(props)}>
            הוספת תזכורת ליומן
          </button>
        </div>
        <div>
          <button
            className={checkIfUpdateAllowed(props) ? 'btn-enabled' : 'btn-disabled'}
            onClick={(e) => showCancelPopUp(props, e.target)}>
            ביטול
          </button>
        </div>
      </Col>
    </Row>
  );

  function closePopUpAndActivateScroll() {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    props.showApprovePopupBusiness(false);
  }

  return (
    <Container className='delivery-slot'>
      <Row>
        <Col className='delivery-slot-container'>
          <div className='slot-row'>
            <Row onClick={() => props.expandElement(props.idx)}>
              <Col xs='2' md='1' className='slot-icon'>
                <Image src={setTitleAndLogo(props.data).logo} alt='לוגו' />
              </Col>
              <Col xs='8' md='6'>
                <div className='slot-title'>{setTitleAndLogo(props.data).title}</div>
                <div className='note'>קיבלנו את פרטי השליחות שלך</div>
              </Col>
              <Col xs='2' md='5'>
                <button
                  ref={focusBtn}
                  type='submit'
                  className={props.elementIndex === props.idx ? 'arrow-shrink' : 'arrow-expand'}
                  backgroundImage={require('../images/icons-arrow.svg')}
                  ></button>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              {props.elementIndex === props.idx ? null : (
                <Col className='delivery-date'>
                  <div>
                    <span>{props.data.dayOfWeek} &nbsp;</span>
                    <span>{props.data.disptachDate} &nbsp; &nbsp;</span>
                    <span>
                      {props.data.roundFrom} - {props.data.roundTo}
                    </span>
                  </div>
                </Col>
              )}
            </Row>
          </div>
          {props.elementIndex === props.idx ? (
            <div>
              {props.isEdit ? editAddress : currentAddress}
              {props.isEdit ? cancelEditModeFooter : editModeFooter}
            </div>
          ) : null}
        </Col>
        <div>
          {props.isApprovePopupShowBusiness && props.elementIndex == props.idx ? (
            <div className='popup-container'>
              <PopUp showPopUp={props.isApprovePopupShowBusiness} onClose={() => closePopUpAndActivateScroll()} id='popup-approve'>
                <div>
                  <p className='cancel-title'>שנבטל את השליחות?</p>
                  <div className='cancel-buttons-area'>
                    <div className='approve-cancel' onClick={(e) => CancelDelivery(props, e.target)}>
                      <div className='d-flex align-items-center justify-content-center'>
                        <span>כן, אפשר לבטל</span>
                        <Image src={require('../images/arrow.svg')} alt='חץ' style={{position: 'relative', top: '-2px', right: '2px'}} />
                      </div>
                    </div>
                    <BtnSubmit onclick={() => closePopUpAndActivateScroll()} text='בעצם לא'></BtnSubmit>
                  </div>
                </div>
              </PopUp>
            </div>
          ) : null}
        </div>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.updateBusinessDeliverySlot.form,
    elementIndex: state.updateBusinessDeliverySlot.elementIndex,
    isEdit: state.updateBusinessDeliverySlot.isEdit,
    isSubmit: state.updateBusinessDeliverySlot.isSubmit,
    isShowFail: state.updateBusinessDeliverySlot.isShowFail,
    addressForm: state.addressForm,
    deliveryTimeSlots: state.updateBusinessDeliverySlot.deliveryTimeSlots,
    populatedCity: state.updateBusinessDeliverySlot.populatedCity,
    populatedStreet: state.updateBusinessDeliverySlot.populatedStreet,
    populatedHome: state.updateBusinessDeliverySlot.populatedHome,
    mode: state.updateBusinessDeliverySlot.mode,
    isApprovePopupShowBusiness: state.updateBusinessDeliverySlot.isApprovePopupShowBusiness,
    updateSuccess: state.updateBusinessDeliverySlot.updateSuccess,
    isSavedSuccessfullyVisible: state.updateBusinessDeliverySlot.isSavedSuccessfullyVisible,
    selectedHetPayId: state.portalsBlock.selectedHetPayId,
    selectedPhoneNumber: state.iMEIDeviceRepair.selectedPhoneNumber,
    selectedIMEI: state.iMEIDeviceRepair.selectedIMEI,
    deviceRepairData: state.iMEIDeviceRepair,
    orgId: state.welcomeBlock.orgId,
  };
};

const mapDispatchToProps = {
  submitSelectedEMEIConfirmation,
  getDeliveryNoProducts,
  deliveryValidateHandler,
  clearTimeSlots,
  startLoading,
  deliveryChangeHandler,
  changeHandler,
  expandElement,
  enableEdit,
  populateForm,
  updateOrCancel,
  showApprovePopupBusiness,
  setHomeNum,
  clearAddress,
  showAppLoader,
  hideAppLoader,
  clearValid,
  setSavedSuccessfullyVisible,
  setIsShowFail,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBusinessDeliverySlot);
